exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Modal__overlay___hDRUY {\n}\n\n.Modal__transOverlay___-hXcg {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.Modal__wrapper___2mA6W {\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    min-height: 100%;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 110;\n}\n\n.Modal__content___27su4 {\n    padding: 20px;\n    background: white;\n    -webkit-box-shadow: 0 0 25px rgba(0,0,0,0.13);\n            box-shadow: 0 0 25px rgba(0,0,0,0.13);\n    width: 90%;\n    max-width: 650px;\n    position: relative;\n}\n\n.Modal__close___10tWW {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"overlay": "Modal__overlay___hDRUY",
	"transOverlay": "Modal__transOverlay___-hXcg",
	"wrapper": "Modal__wrapper___2mA6W",
	"content": "Modal__content___27su4",
	"close": "Modal__close___10tWW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Modal/Modal.css
// module id = 452
// module chunks = 0